export default __webpack_public_path__ + "static/logo-43ef440d2fbbd569fb5fa07a6c3f0f6e.svg";